var exports = {
  "P": "MentionRenderer.module__label___eXlSUF",
  "p": "MentionRenderer.module__channelIcon___eXlSUF",
};

module.exports = exports;
